// src/services/referralsService.js
// Реферальные рекомендации «вместо водителя» — паритет с панели водителя (ReferralProgram.js).
import { collection, addDoc, serverTimestamp, getDocs, doc, getDoc } from 'firebase/firestore';

export const addReferralForUser = async ({ firestore, user, phone, email }) => {
  const recommendedBy = {
    uid: user.uid,
    firstName: user.firstName || '',
    lastName: user.lastName || '',
    phoneNumber: user.phoneNumber || user.phone || '',
  };
  const referalDocRef = await addDoc(collection(firestore, 'ReferalProgram'), {
    recommendedBy,
    phone: phone || '',
    email: email || '',
    timestamp: serverTimestamp(),
    status: 'Oczekuje',
  });
  await addDoc(collection(firestore, `users/${user.uid}/ReferalProgram`), {
    referalDocId: referalDocRef.id,
    timestamp: serverTimestamp(),
  });
  return referalDocRef.id;
};

export const fetchReferralsForUser = async ({ firestore, uid }) => {
  const snap = await getDocs(collection(firestore, `users/${uid}/ReferalProgram`));
  const results = [];
  for (const d of snap.docs) {
    const refId = d.data().referalDocId;
    if (!refId) continue;
    const refDoc = await getDoc(doc(firestore, 'ReferalProgram', refId));
    if (refDoc.exists()) results.push({ id: refDoc.id, ...refDoc.data() });
  }
  return results;
};
